// Cross-platform haptics helper.
// Prefers Capacitor's native Haptics plugin on iOS/Android (works inside a
// Capacitor wrapper — iOS Safari's standalone browser doesn't expose
// navigator.vibrate). Falls back to navigator.vibrate on Android web, and
// silently no-ops on iOS Safari where neither is available.

import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";

const isNative = () => {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

// Small, gentle tick — used when the distress slider value changes.
export const hapticTick = async () => {
  if (isNative()) {
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
      return;
    } catch {
      /* fall through to web */
    }
  }
  if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
    try { navigator.vibrate(8); } catch { /* ignore */ }
  }
};

// Medium confirmation — used when the user commits a value (advance).
export const hapticConfirm = async () => {
  if (isNative()) {
    try {
      await Haptics.impact({ style: ImpactStyle.Medium });
      return;
    } catch {
      /* fall through */
    }
  }
  if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
    try { navigator.vibrate(18); } catch { /* ignore */ }
  }
};

// Celebratory triple-pulse — used when the user hits SUD 0 or 1.
export const hapticCelebrate = async () => {
  if (isNative()) {
    try {
      await Haptics.notification({ type: NotificationType.Success });
      return;
    } catch {
      /* fall through */
    }
  }
  if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
    try { navigator.vibrate([20, 40, 60]); } catch { /* ignore */ }
  }
};
